import React from "react";
import { Route } from "react-router-dom";

// Lazy-loaded components
const EventBrowser = React.lazy(() =>
  import(
    "@/modules/learningCenter/features/TrainingSystem/components/EventBrowser"
  ).then((module) => ({
    default: module.EventBrowser,
  })),
);

const EnrollmentsList = React.lazy(() =>
  import(
    "@/modules/learningCenter/features/TrainingSystem/components/EnrollmentsList"
  ).then((module) => ({
    default: module.EnrollmentsList,
  })),
);

/**
 * Training System feature routes
 *
 * Routes:
 * - /training/events - Browse and register for training events
 * - /training/my-enrollments - View user's enrollments and pre-work
 */
const TrainingSystemRoutes = (
  <>
    <Route element={<EventBrowser />} path="/training/events" />
    <Route element={<EnrollmentsList />} path="/training/my-enrollments" />
  </>
);

export default TrainingSystemRoutes;
